export default __webpack_public_path__ + "0b64a0c0c631c5448c9aae27566f7261.png";